// remove leading/trailing and double spaces
export const sanitizeSearchTerm = (q: string) => q.trim().replace(/\s{2,}/g, ' ');
